import React from 'react';
import { StringConstantsMixin } from '../../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import * as styles from '../styles/styles.module.scss';
import { wrapEventHandler } from '../../../../utils/handlers';

export type EditDeleteGroupProps = {
  onButtonClick: (e: React.MouseEvent) => void;
  onLinkClick: (e: React.MouseEvent) => void;
  editable?: boolean;
};

const EditDeleteGroup = ({ onButtonClick, onLinkClick, editable = false }: EditDeleteGroupProps): JSX.Element => (
  <>
    <button type="button" onClick={wrapEventHandler(onButtonClick)} className={`${styles.link} ${styles.action}`} data-testid="deleteReview">
      {StringConstantsMixin.strings.DELETE}
    </button>
    <a
      href={editable ? '#edit-review' : null}
      onClick={onLinkClick}
      className={`${styles.link} ${styles.action}`}
      rel="nofollow"
      data-testid="editReview"
    >
      {editable ? StringConstantsMixin.strings.EDIT : StringConstantsMixin.strings.COMMENT}
    </a>
  </>
);

export default EditDeleteGroup;
